<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_27620_297289)">
      <path
        d="M11.9987 4.77203C11.9587 4.76536 11.9121 4.76536 11.8721 4.77203C10.9521 4.7387 10.2188 3.98536 10.2188 3.05203C10.2188 2.0987 10.9854 1.33203 11.9387 1.33203C12.8921 1.33203 13.6587 2.10536 13.6587 3.05203C13.6521 3.98536 12.9187 4.7387 11.9987 4.77203Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3169 9.62547C12.2302 9.7788 13.2369 9.6188 13.9435 9.14547C14.8835 8.5188 14.8835 7.49214 13.9435 6.86547C13.2302 6.39214 12.2102 6.23213 11.2969 6.39213"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.98031 4.77203C4.02031 4.76536 4.06698 4.76536 4.10698 4.77203C5.02698 4.7387 5.76031 3.98536 5.76031 3.05203C5.76031 2.0987 4.99365 1.33203 4.04031 1.33203C3.08698 1.33203 2.32031 2.10536 2.32031 3.05203C2.32698 3.98536 3.06031 4.7387 3.98031 4.77203Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.6676 9.62547C3.75427 9.7788 2.7476 9.6188 2.04094 9.14547C1.10094 8.5188 1.10094 7.49214 2.04094 6.86547C2.75427 6.39214 3.77427 6.23213 4.6876 6.39213"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99875 9.7525C7.95875 9.74583 7.91208 9.74583 7.87208 9.7525C6.95208 9.71917 6.21875 8.96583 6.21875 8.0325C6.21875 7.07916 6.98542 6.3125 7.93875 6.3125C8.89208 6.3125 9.65875 7.08583 9.65875 8.0325C9.65208 8.96583 8.91875 9.72583 7.99875 9.7525Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.06437 11.8542C5.12437 12.4809 5.12437 13.5076 6.06437 14.1342C7.13104 14.8476 8.8777 14.8476 9.94437 14.1342C10.8844 13.5076 10.8844 12.4809 9.94437 11.8542C8.88437 11.1476 7.13104 11.1476 6.06437 11.8542Z"
        :stroke="color"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_27620_297289">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup>
import { defineProps } from "vue";
defineProps({
  color: {
    type: String,
    default: "black",
  },
});
</script>
